// eslint-disable-next-line
export let userData = $state({});
// eslint-disable-next-line
export let uiState = $state({ nextSteps: { expanded: true } });
